<template>
  <div>
    <div class="lan-dong">
      <span class="text-gray-style">{{$t('certManage.cert')}}</span>
      <div style="margin-top: 24px">
        <CDNRadios
          v-model="UserAgentAction"
          :items="items1"
          :label="$t('allDomain.applyMethod')"
          :hasLine="false"
        />
      </div>
    </div>
    <div class="" v-if="UserAgentAction === 0">
      <div class="lan-dong">
        <span class="text-gray-style">{{$t('allDomain.certContent')}}</span>

        <div style="margin-top: 24px">
          <el-input type="textarea" :rows="5" v-model="certContent"> </el-input>
          <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
            {{ $t('allDomain.tip44') }}
          </div>
        </div>
      </div>

      <div class="lan-dong">
        <span class="text-gray-style">{{$t('allDomain.tip55')}}</span>
        <div style="margin-top: 24px">
          <el-input type="textarea" :rows="5" v-model="syContent"> </el-input>
          <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
            {{ $t('allDomain.tip44') }}
          </div>
        </div>
      </div>
      <!-- <div class="text-class">申请类型：手动上传</div>
      <div class="text-class">到期时间：1970-01-01 08:00:00</div> -->
    </div>
    <div v-if="UserAgentAction === 1">
      <CDNRadios
          v-model="dnstype"
          :items="dnstypeItems"
          :label="$t('allDomain.tip66')"
          :hasLine="false"
        />

      <div class="lan-dong" v-if="myCname.length > 0">
        <span class="text-gray-style">cname</span>

        <div style="margin-top: 24px">
          {{this.myCname.replace('指向别名', 'points to the alias')}}
        </div>
      </div>

      <div class="lan-dong" v-if="r_certContent.length > 0">
        <span class="text-gray-style">{{$t('allDomain.certContent')}}</span>

        <div style="margin-top: 24px">
          <el-input type="textarea" disabled :rows="5" v-model="r_certContent"> </el-input>
        </div>
      </div>

      <div class="lan-dong" v-if="r_syContent.length > 0">
        <span class="text-gray-style">{{$t('allDomain.tip55')}}</span>
        <div style="margin-top: 24px">
          <el-input type="textarea" disabled :rows="5" v-model="r_syContent"> </el-input>
        </div>
      </div>

    </div>
    <div class="btn-commit" @click="commit">
      {{ $t("product.commit") }}
    </div>

  </div>
</template>

<script>
/* eslint-disable */
import { uploadCert, applyCert, configCN, apiCertDetail } from "@/service/requestRes";
export default {
  props: {
    domainHost: String,
    cname: String,
  },
  data() {
    return {
      UserAgentAction: 0,
      certContent: "",
      syContent: "",
      r_certContent: "",
      r_syContent: "",
      matchUserAgnet1: "",
      dnstype: null,
    };
  },
  computed: {
    myCname() {
      return this.cname;
    },
    items1() {
      return [
        {
          label: this.$t('certManage.ManualUpload'),
          value: 0,
        },
        {
          label: this.$t('allDomain.tip77'),
          value: 1,
        },
      ];
    },
    dnstypeItems() {
      return [
        {
          label: "dns01",
          value: 0,
        },
        {
          label: "http01",
          value: 1,
        },
      ];
    },
  },
  watch: {
    cname(val) {
      this.myCname = val;
    }
  },
  mounted() {
    this.getCert();
  },  
  methods: {
    getCert(){
      apiCertDetail(this.domainHost).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const {ssl_type, ssl_cert, ssl_key} = data || {};
          if (ssl_type == 0) {
            this.UserAgentAction = 0;
            this.certContent = atob(ssl_cert) || '';
            this.syContent = atob(ssl_key) || '';
          } else {
            this.UserAgentAction = 1;
            this.r_certContent = atob(ssl_cert) || '';
            this.r_syContent = atob(ssl_key) || '';
            this.dnstype = ssl_type == 1 ? 1 : 0;
          }
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    uploadMycert({ ssl_cert, ssl_key }) {
      uploadCert({ ssl_cert, ssl_key, host: this.domainHost }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t('allDomain.tip114'),
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    applyMyCert() {
      let dnstype_str = (this.dnstype==0) ? "dns01" : "http01";
      applyCert(this.domainHost, dnstype_str).then((res) => {
        let { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t('allDomain.tip115'),
            type: "success",
          });
        } else {
          if (msg === '请勿重复申请') {
            msg = 'Please do not repeat the application';
          }
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    configCNMethod(obj) {
      configCN({
        ...obj,
        host: this.domainHost,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t('allDomain.tip113'),
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    commit() {
      if (!this.UserAgentAction) {
        if (!this.certContent) {
          this.$message({
            message: this.$t('allDomain.tip116'),
            type: "success",
          });
          return;
        }
        if (!this.syContent) {
          this.$message({
            message: this.$t('allDomain.tip117'),
            type: "success",
          });
          return;
        }
        this.uploadMycert({
          ssl_cert: this.certContent,
          ssl_key: this.syContent,
        });
      } else {
        this.applyMyCert();
      }
    },
    HstsChange(e) {
      const lockHSTS = { func: "lockHSTS", host: this.domainHost, lockHSTS: e };
      this.configCNMethod(lockHSTS);
    },
    forceChange(e) {
      const lockHttps = {
        func: "lockHttps",
        host: this.domainHost,
        lockHttps: e,
      };

      this.configCNMethod(lockHttps);
    },
    oldSiteChange(e) {
      const openCSPCheat = {
        func: "openCSPCheat",
        host: this.domainHost,
        openCSPCheat: e,
      };

      this.configCNMethod(openCSPCheat);
    },
  },
};
</script>

<style lang="scss" scoped>
.cenue-title {
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #131523;
}

.lan-dong {
  margin-top: 28px;
  .checkbox-content {
    margin-top: 6px;
    display: flex;
    align-items: center;
  }
}

.margin-top {
  margin-top: -15px;
}

.btn-commit {
  padding: 8px 44px;
  margin: 24px 0px;
  width: 120px;
  background: #d9e4ff;
  border-radius: 4px;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #1e5eff;
  cursor: pointer;
}
.row-line {
  display: flex;
  align-items: flex-end;
  margin-bottom: 36px;
  .new-add {
    padding: 8px 44px;
    width: 120px;
    height: 40px;
    background: #d9e4ff;
    border-radius: 4px;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #1e5eff;
    cursor: pointer;
    margin-left: 10px;
    margin-bottom: 6px;
  }
}

.lan-dong-link {
  display: flex;
  margin-top: 24px;
}
.handle-first {
  cursor: pointer;
}
.cenum-setting {
  padding: 21px 0;
}
.my-line {
  width: 100%;
  height: 3px;
  background-color: #1e5eff;
  margin: 48px 0 24px 0;
}
.text-class {
  font-size: 14px;
  color: #666666;
  margin-top: 24px;
  margin-bottom: 24px;
}
</style>
